import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./sidebar.module.css";
import { get } from "util/requests";
import router from "routes";
import { OpenQueryIcon, RespondedQueryIcon, ResolvedQueryIcon, CheckIcon } from "ui/icons";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useSearchParams, useParams } from "react-router-dom";

const layer1 = [styles.sidebar_layer, styles.sidebar_layer1].join(" ");
const layer2 = [styles.sidebar_layer, styles.sidebar_layer2].join(" ");
const layer2_active = [styles.sidebar_layer, styles.sidebar_layer2, styles.layer2_active].join(" ");
const layer3 = [styles.sidebar_layer, styles.sidebar_layer3].join(" ");
const layer3_active = [styles.sidebar_layer, styles.sidebar_layer3, styles.layer2_active].join(" ");
const renderRowIcon = (props) => {
  const { crf_status } = props;
  if (crf_status === "checked") {
    return <CheckIcon fontSize={"16px"} />;
  } else if (crf_status === "open") {
    return <OpenQueryIcon fontSize={"16px"} />;
  } else if (crf_status === "resolved") {
    return <ResolvedQueryIcon fontSize={"16px"} />;
  } else if (crf_status === "responded") {
    return <RespondedQueryIcon fontSize={"16px"} />;
  } else {
    return null; //<PanoramaFishEyeIcon sx={{ color: "#bbb", fontSize: "16px", lineHeight: "16px" }} />;
  }
};

const Row = function (props) {
  const { site_id, study_id, subject_id, url_params, subjectData, active_subject_id } = props;
  const { tab_id } = useParams();
  const handleKeyDown = (event) => {
    let index = subjectData.findIndex((s) => s.id === active_subject_id);
    let next_subject = subjectData[index];
    if (event.key === "ArrowDown") {
      if (index !== subjectData.length - 1) {
        next_subject = subjectData[index + 1];
      }
      event.preventDefault(); // Prevent default browser behavior (e.g., scrolling)
      if (url_params.site) {
        props.navigate(`/subjects/${next_subject.id}/${tab_id}?site=${url_params.site}`);
      } else {
        props.navigate(`/subjects/${next_subject.id}/${tab_id}`);
      }
    } else if (event.key === "ArrowUp") {
      if (index !== 0) {
        next_subject = subjectData[index - 1];
      }
      if (url_params.site) {
        props.navigate(`/subjects/${next_subject.id}/${tab_id}?site=${url_params.site}`);
      } else {
        props.navigate(`/subjects/${next_subject.id}/${tab_id}`);
      }
    }
  };
  return (
    <div
      className={props.active ? layer3_active : layer3}
      onKeyDown={handleKeyDown}
      tabIndex="0"
      onClick={() => {
        if (url_params.site) {
          props.navigate(`/subjects/${subject_id}/${tab_id}?site=${url_params.site}`);
        } else {
          props.navigate(`/subjects/${subject_id}/${tab_id}`);
        }
      }}
    >
      <div>{props.name}</div>
      <div>{renderRowIcon(props)}</div>
    </div>
  );
};

export default function EDCGridSideBar(props) {
  const [search_params = [], setSearchParams] = useSearchParams();
  const [subjectData, setSubjectData] = useState([]);
  const [sites, setSites] = useState([]);
  const active_study_id = useSelector((state) => state.study.active_study_id);
  const { tab_id } = useParams();

  let params = {};
  search_params.forEach((value, key) => (params[key] = value));

  useEffect(() => {
    let filters = {};
    if (params.site) {
      filters = { site: params.site };
    }
    get(`/patient_grid_sidebar_data/${active_study_id || 1}`, { params: { ...filters } }).then((ret) =>
      setSubjectData(ret.data)
    );
    get("/site_region_list_user_context").then((ret) => {
      let sites = ret.data.sites;
      sites.unshift({ name: "All Sites", code: "all", id: 0 });
      setSites(sites);
    });
  }, [params.site]);

  return (
    <div className={styles.sidebar}>
      {sites?.length > 1 ? (
        <div className={styles.select_wrapper}>
          <Select
            value={params.site || 0}
            sx={{
              fontSize: 14,
              minWidth: 180,
              maxWidth: 180,
              height: 30,
              padding: 0,
              alignSelf: "center",
            }}
            onChange={(e) => {
              // setSelectedDomain(e.target.value);
              let _params = { ...params };
              if (e.target.value === 0) {
                delete _params.site;
              } else {
                _params.site = e.target.value;
              }
              setSearchParams(_params);
            }}
          >
            {sites?.map((o) => (
              <MenuItem key={o.code} value={o.id}>
                {`${o.name}${o.code !== "all" ? ` (${o.code})` : ""} `}
              </MenuItem>
            ))}
          </Select>
        </div>
      ) : null}

      <div className={layer2}>
        <div>
          <strong>Subjects</strong>
        </div>
      </div>

      <div className={styles.sidebar_scroll}>
        {subjectData &&
          subjectData.map((subject) => (
            <Row
              key={subject.id}
              name={subject.id}
              subject_id={subject.id}
              study_id={active_study_id}
              site_id={props.site_id}
              active={subject.id === parseInt(props.subject_id)}
              crf_status={subject.crf_status}
              navigate={router.navigate}
              url_params={params}
              subjectData={subjectData}
              active_subject_id={parseInt(props.subject_id)}
            />
          ))}
      </div>
    </div>
  );
}
